<template>
  <div class="c-modal c-modal--leaderboard">
    <div class="c-modal__box c-modal--leaderboard__box">
      <div class="c-modal__box__header t-modal-header">
        <h2 class="c-modal__box__header__title t-modal-header__text qa-leaderboard-modal-title">
          {{ leaderboardModalData.title }}
        </h2>

        <div class="c-modal__box__header__close">
          <button
            @click = "close()"
            class = "c-modal__box__header__close__button t-modal-header__close"
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>


      <div class="c-modal__box__content">
        <table class="c-modal--leaderboard__table">
          <thead>
            <tr>
              <th v-for="field in leaderboardModalData.headers">
                {{ field }}
              </th>
            </tr>
          </thead>

          <tbody id="leaderboard-table__body">
            <tr v-for="(record, index) in leaderboardReportData">
              <td
                class  = "c-modal--leaderboard__rank t-leaderboard-rank"
                :class = "isPersonalPosition(record) ? 'qa-leaderboard-my-row-rank' : ''"
              >
                {{ getRank(index + 1) }}
              </td>

              <td
                v-for  = "(field, fieldIndex) in record"
                v-if   = "typeof field.id === 'undefined'"
                :class = "isPersonalPosition(record) && fieldIndex === 1 
                          ? 'qa-leaderboard-my-row-name' : ''"
              >
                {{ formatFieldValue(field, fieldIndex) }}<span
                  v-if        = "isPersonalPosition(record) && fieldIndex === 1"
                  id          = "personal-position"
                  class       = "fa fa-check-circle
                                 c-modal--leaderboard__table__icon__row__me
                                 t-leaderboard-rank
                                 qa-leaderboard-modal-my-row-icon"
                  aria-hidden = "false"
                ><i class="u-hide">{{ $t('web.leaderboard_modal.hidden_you_indicator') }}</i></span>
              </td>
            </tr>
          </tbody>
        </table>

        <paginate
          :pagination     = "pagination"
          :pagingCallback = "goToPage"
        ></paginate>

      </div>
    </div>


    <div class="c-modal__overlay"></div>
  </div>
</template>




<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import $ from 'jquery'
import API from '@/services'
import util from '@/functions'
import Paginate from '@/views/components/shared/Paginate'

export default {
  name: 'LeaderboardModal',
  components: {
    Paginate
  },
  data () {
    return {
      leaderboardReportData: [],
      currentPage: 1,
      perPage: 100
    }
  },
  computed: {
    ...mapGetters({
      reportData: 'reportData',
      participant: 'participant',
      leaderboardModalData: 'leaderboardModalData'
    }),
    totalRecords () {
      return this.leaderboardModalData.recordsTotal
    },
    pagination () {
      let totalPages = Math.ceil(this.leaderboardModalData.recordsTotal / this.perPage)
      let pages = util.getPagination(this.currentPage, totalPages)

      let pagination = {
        current: this.currentPage,
        per_page_count: this.perPage,
        count: this.leaderboardModalData.recordsTotal,
        pages: pages
      }

      pagination.previous = (this.currentPage === 1) ? null : this.currentPage - 1
      pagination.next = (this.currentPage === _.last(pagination.pages)) ? null : this.currentPage + 1

      return pagination
    }
  },
  mounted () {
    this.leaderboardReportData = this.reportData[this.leaderboardModalData.report_id]
    this.initialize()
  },
  methods: {
    initialize () {
      let participantPosition = util.getParticipantPosition(this.participant.id, this.leaderboardReportData)
      // Using this index because on mobile views the modal header will overlap the the element above my position
      let index = window.innerWidth > 720 ? 1 : 2
      let record = $(this.$el).find('#leaderboard-table__body')[0].children[participantPosition - index]
      if (record !== null && typeof record !== 'undefined') {
        record.scrollIntoView({block: 'start', behavior: 'instant'})
      }
    },
    isPersonalPosition (record) {
      for (let i = 0; i < record.length; i++) {
        if (typeof record[i].id !== 'undefined' && record[i].id === this.participant.id) {
          return true
        }
      }
      return false
    },
    formatNumber (value) {
      return util.formatNumber(value)
    },
    getRank (value) {
      value = value + ((this.currentPage * this.perPage) - this.perPage)

      return this.formatNumber(value)
    },
    /**
     * Takes the field value and its column index and returns the formatted
     * value based on the column field type
     *
     * @param {string} value Field value
     * @param {number} index Column index
     * @return {string}
     */
    formatFieldValue (value, index) {
      let type = this.leaderboardModalData.fields[index] && this.leaderboardModalData.fields[index].type
      let numberTypes = ['integer', 'currency', 'decimal', 'percent']
      if (numberTypes.indexOf(type) !== -1) {
        return this.formatNumber(value)
      }
      return value
    },
    goToPage (page) {
      this.currentPage = page
      let start = (page * this.perPage) - this.perPage

      API.getAuthenticated('/cards/' + this.leaderboardModalData.id + '?' + `start=${start}&legth=${this.perPage}`)
        .then(resp => {
          this.leaderboardReportData = resp.data.records
          this.initialize()
        })
        .catch(err => {
          console.log(err)
        })
    },
    close () {
      $('body').removeClass('has-modal')
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_SHOW', false)
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_DATA', null)
    }
  }
}

</script>



// WEBPACK FOOTER //
// LeaderboardModal.vue?0d6114a0